// Helpers genericos compartilhados entre os parsers de planilhas .xlsm/.xlsx.
// Originalmente extraidos de planilhaClient.jsx para permitir reuso pela
// segunda fonte de dados (DISTRIBUICAO DE PROJETOS).

export function letterToIndex(letter) {
  return String(letter)
    .toUpperCase()
    .split("")
    .reduce((total, char) => total * 26 + char.charCodeAt(0) - 64, 0) - 1;
}

function dateToISO(value) {
  if (Number.isNaN(value.getTime())) return null;
  const year = value.getUTCFullYear();
  const month = String(value.getUTCMonth() + 1).padStart(2, "0");
  const day = String(value.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

// Conversor type-aware. Para campos sem tipo declarado mantem o
// comportamento legado (string) para nao quebrar telas existentes.
export function cellToTyped(value, expectedType = "text") {
  if (value === null || value === undefined || value === "") return null;

  if (expectedType === "number" || expectedType === "money") {
    if (value instanceof Date) {
      // C-019: celula contem Date onde se esperava quantidade.
      return null;
    }
    if (typeof value === "number") return value;
    const s = String(value).replace(",", ".").trim();
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
  }

  if (expectedType === "date") {
    if (value instanceof Date) return dateToISO(value);
    if (typeof value === "number") {
      // "Data zero" do INDEX/MATCH vazio: o Excel devolve 0 e SheetJS converte
      // em 1899-12-30. Tratamos como ausencia de data.
      if (value === 0) return null;
      const ms = (value - 25569) * 86400 * 1000;
      const d = new Date(ms);
      return Number.isNaN(d.getTime()) ? null : dateToISO(d);
    }
    const s = String(value).trim();
    return s || null;
  }

  if (value instanceof Date) {
    return dateToISO(value);
  }
  const s = String(value).trim();
  return s || null;
}

export function cellToString(value) {
  return cellToTyped(value, "text");
}

export function validarArquivoPlanilha(filename) {
  const extension = String(filename || "").split(".").pop()?.toLowerCase();
  if (!["xlsm", "xlsx"].includes(extension)) {
    throw new Error("Selecione um arquivo .xlsm ou .xlsx.");
  }
}

// Detecta valor de erro do Excel (#REF!, #N/A, #NAME?, etc) em uma celula.
export function ehErroExcel(value) {
  if (typeof value !== "string") return false;
  return /^#(REF|N\/A|NAME|VALUE|DIV\/0|NULL|NUM)/i.test(value.trim());
}
